import { MultiStepModalProps } from '@frontend/design-system';
import { CreateSoftphoneStepper } from '../../../components/devices/create-softphone';

export const CreateSoftphoneIndex = (modalControls: MultiStepModalProps) => {
  return <CreateSoftphoneStepper {...modalControls} />;
};
